module.exports = __webpack_public_path__ + "img/doubao-icon.fa88b9b6.png";